import moment from 'moment';

export const WEEK_ENDING_PREFIX = 'W/E ';

export const formatVerboseWeek = ({
  startDate,
  isYearImportant,
}: {
  startDate: string;
  isShort?: boolean;
  isYearImportant: boolean;
}) => {
  const endMoment = moment.utc(startDate).add({ day: 6 });
  const format = isYearImportant ? `MMM DD 'YY` : `MMM DD`;
  return `${WEEK_ENDING_PREFIX}${endMoment.format(format)}`;
};

const formatDateLabel = (
  term: string | number,
  interval: FleetOps.Interval | 'fixed' | 'fiscalPeriod',
  useShortLabel?: boolean,
  dateRange?: { startDate: string; endDate?: string },
  isMatrix?: boolean,
  isYearImportant?: boolean,
  suppressWeekEndingPrefix?: boolean,
) => {
  let endQ;

  const t = dateRange ? dateRange.startDate : term;
  const tEnd = dateRange ? dateRange.endDate : undefined;

  switch (interval) {
    case 'hour':
      if (useShortLabel) {
        return moment.utc(t).format('MM/DD ha');
      } else {
        return moment.utc(t).format("MMM DD 'YY ha");
      }
    case 'month':
      if (useShortLabel) {
        return moment.utc(t).format("MM 'YY");
      } else {
        return moment.utc(t).format("MMM 'YY");
      }
    case 'week': {
      // We are adding 6 days here to reflect how our queries work — weeks are
      // labelled by their ending date (customers refer to weeks as "week ending …").
      const endMoment = tEnd ? moment.utc(tEnd) : moment.utc(term).add(6, 'd');
      const prefix = suppressWeekEndingPrefix ? '' : WEEK_ENDING_PREFIX;
      const format = isYearImportant ? `MM/DD 'YY` : 'MM/DD';
      return `${prefix}${endMoment.format(format)}`;
    }
    case 'year':
      return moment.utc(t).format(`YYYY`);
    case 'quarter':
      endQ = tEnd
        ? moment.utc(tEnd).format("Q 'YY")
        : moment.utc(term).add(1, 'quarter').format("Q 'YY");

      if (moment.utc(t).format("Q 'YY") === endQ) {
        return moment.utc(t).format(`[Q]Q' YY`);
      } else {
        return moment.utc(t).format(`[Q]Q' YY - [Q]${endQ}`);
      }
    case 'day':
    case 'auto':
    default:
      if (isMatrix) {
        if (useShortLabel) {
          return moment.utc(t).format('ddd, MM/DD');
        } else {
          return moment.utc(t).format("ddd, MMM DD 'YY");
        }
      } else {
        if (useShortLabel) {
          return moment.utc(t).format('MM/DD');
        } else {
          return moment.utc(t).format("MMM DD 'YY");
        }
      }
  }
};

export default formatDateLabel;
